import { render, staticRenderFns } from "./MinMaxStock.vue?vue&type=template&id=f81a2818&scoped=true&"
import script from "./MinMaxStock.vue?vue&type=script&lang=ts&"
export * from "./MinMaxStock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81a2818",
  null
  
)

export default component.exports